'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Land = require('../entity').Land;

module.exports = function (connection) {
  return {
    byAlpha2codeEquals: function byAlpha2codeEquals(alpha, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byAlpha2codeEquals', 'alpha')(alpha, additionalParams);
    },
    byAlpha2codeLike: function byAlpha2codeLike(alpha, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byAlpha2codeLike', 'alpha')(alpha, additionalParams);
    },
    byAlpha3codeEquals: function byAlpha3codeEquals(alpha, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byAlpha3codeEquals', 'alpha')(alpha, additionalParams);
    },
    byAlpha3codeLike: function byAlpha3codeLike(alpha, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byAlpha3codeLike', 'alpha')(alpha, additionalParams);
    },
    byNameDEEquals: function byNameDEEquals(namede, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byNameDEEquals', 'namede')(namede, additionalParams);
    },
    byNameDELike: function byNameDELike(namede, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byNameDELike', 'namede')(namede, additionalParams);
    },
    byNameENEquals: function byNameENEquals(nameen, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byNameENEquals', 'nameen')(nameen, additionalParams);
    },
    byNameENLike: function byNameENLike(nameen, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byNameENLike', 'nameen')(nameen, additionalParams);
    },
    byNumericCodeEquals: function byNumericCodeEquals(numericcode, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'byNumericCodeEquals', 'numericcode')(numericcode, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Land, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Land, 'genericand')(searchParams);
    },
    byMultiValueSearchRep: function byMultiValueSearchRep(searchParams) {
      return templates.genericSearchTemplate(connection)(Land, 'byMultiValueSearchRep')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('land')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/land.js
// module id = EmJW
// module chunks = 0